import { getService } from '../../utils';

export const getUsersService = getService('users');
